<template>
  <div>
    <div class="industry">
      <div class="search">
        <el-input
          placeholder="关键字"
          v-model="searchValue"
          style="width: 50%;"
          @change="search"
          size="medium"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search"
            size="medium"
          ></el-button>
        </el-input>
        <upload v-if="editable"></upload>
      </div>

      <div class="tag">
        <el-tag
          v-for="(tag, index) in menu"
          :key="index"
          @click="selectMenu(index)"
          type="warning"
          size="small"
          :effect="currentMenu == index ? 'dark' : 'light'"
          >{{ tag }}</el-tag
        >
      </div>
      <news-list
        :data="data"
        :editable="editable"
        @collect="collectNews"
        @refresh="refreshNews"
      ></news-list>
      <el-drawer
        :visible.sync="showLeft"
        :with-header="false"
        :append-to-body="true"
      >
        <div class="industry-drawer">
          <h4>我的收藏</h4>
          <el-table
            ref="collectTable"
            :data="collectList"
            :show-header="false"
            @selection-change="collectSelect"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column label>
              <template slot-scope="scope">
                <router-link :to="`/industry/detail/${scope.row.id}`">
                  {{ scope.row.title }}
                </router-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="bottom-tool">
            <el-button type="text" @click="checkAll">全选</el-button>
            <el-button type="text" @click="uncheckAll">取消全选</el-button>
            <el-button type="text" @click="remove">删除所选</el-button>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
// v-infinite-scroll="load"
import isEmpty from 'lodash/isEmpty';

import NewsList from './components/news-list';
import Upload from './components/upload';

export default {
  components: {
    NewsList,
    Upload
  },
  data() {
    return {
      searchValue: '',
      currentMenu: 0,
      menu: ['全部', '政策信息', '行业信息', '前瞻技术', '招投标信息'],
      data: [],
      showLeft: false,
      collectList: [],
      collectSelection: [],
      editable: true
    };
  },
  computed: {
    canManage() {
      return this.$hasPermission('industryManager');
    }
  },
  watch: {
    showLeft(val) {
      if (val && isEmpty(this.collectList)) {
        this.getCollectList();
      }
    }
  },
  methods: {
    selectMenu(tag) {
      this.currentMenu = tag;
      this.search();
    },
    load() {
      this.count += 2;
    },
    async search() {
      let url = '/windfarm/news/getIndustryNewsList';
      const params = { param: this.searchValue, isManager: 1 };
      if (this.currentMenu !== 0) {
        url = '/windfarm/news/getIndustryNewsListByType';
        params.type = this.currentMenu;
      }
      const res = await this.$fetch(url, {
        params,
        showError: true
      });
      this.data = res.data.newsList;
    },
    async getCollectList() {
      const res = await this.$fetch('/windfarm/news/getMyCollectionList', {
        params: { param: this.searchValue },
        showError: true
      });
      this.collectList = res.data.myNewsList;
    },
    collectNews() {
      this.collectList = [];
    },
    collectSelect(val) {
      this.collectSelection = val;
    },
    refreshNews() {
      this.search();
    },
    checkAll() {
      this.$refs.collectTable.clearSelection();
      this.$refs.collectTable.toggleAllSelection();
    },
    uncheckAll() {
      this.$refs.collectTable.clearSelection();
    },
    async remove() {
      if (isEmpty(this.collectSelection)) {
        return;
      }
      await this.$postForm({
        url: '/windfarm/news/deleteMyCollection',
        data: { ids: this.collectSelection.map(item => item.id).join(',') },
        showError: true,
        showSuccess: true
      });
      this.getCollectList();
    }
  },
  mounted() {
    this.search();
  }
};
</script>

<style lang="less" scoped>
.tag {
  padding: 10px;
}
/deep/.el-tag {
  margin-right: 10px;
  font-size: 14px;
  cursor: pointer;
}
/deep/.el-main {
  background-color: #f6f6f6 !important;
}
.industry {
  margin: 40px;

  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style lang="less">
.industry-drawer {
  h4 {
    margin-left: 20px;
  }

  .bottom-tool {
    font-size: 4px;
    position: absolute;
    bottom: 0px;
    right: 0px;
    left: 0px;
    background-color: @bgColor;
    text-align: left;
    color: #000000;
    padding: 0 10px;
  }
}
</style>
